import PropTypes from "prop-types";
import Text from "components/residency/Text";
import styles from "components/residency/Question.module.scss";

export default function Question({ question, answer }) {
  return (
    <div className={styles.component}>
      <Text className={styles.question}>{question}</Text>
      <Text size="sm" className={styles.answer}>
        {answer}
      </Text>
    </div>
  );
}

Question.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};
